// Function to update the wishlist count
function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const countElement = document.getElementById('wishlist-count');
    if (wishlist.length > 0) {
        countElement.textContent = wishlist.length;
        countElement.style.display = 'inline-block'; // Show count
    } else {
        countElement.textContent = '0';
        countElement.style.display = 'none'; // Hide when no items
    }
}

// Function to add a product to the wishlist
function addToWishlist(productId) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    if (!wishlist.includes(productId)) {
        wishlist.push(productId);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }
    updateWishlistCount(); // Update count immediately
}

// Function to remove a product from the wishlist
function removeFromWishlist(productId) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist = wishlist.filter(id => id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlistCount(); // Update count immediately
}

// Event Delegation for Add/Remove Wishlist Buttons
document.addEventListener('click', function (event) {
    // Add to Wishlist
    if (event.target.classList.contains('add-to-wishlist')) {
        const productId = event.target.getAttribute('data-product-id');
        addToWishlist(productId);
    }

    // Remove from Wishlist
    if (event.target.classList.contains('remove-from-wishlist')) {
        const productId = event.target.getAttribute('data-product-id');
        removeFromWishlist(productId);
    }
});

// Initialize the wishlist count on page load
document.addEventListener('DOMContentLoaded', updateWishlistCount);







